import { render, staticRenderFns } from "./fileDownload.vue?vue&type=template&id=37b8d181&"
import script from "./fileDownload.vue?vue&type=script&lang=ts&"
export * from "./fileDownload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports